import { useTexture } from "@react-three/drei";
import { BackSide } from "three";
import './styles.css'; 
import './index.css'; 
import './App.css'; 

export function SphereEnv() {
  const map = useTexture("assets/textures/envmap.jpg");

  return <mesh>
    <sphereGeometry args={[60, 50, 50]} />
    <meshBasicMaterial 
      side={BackSide}
      map={map}
    />
  </mesh>
}